module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"À la carte","short_name":"À la carte","start_url":"/","background_color":"#EA5500","theme_color":"#EA5500","display":"minimal-ui","icon":"src/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"2abf11c9246998f4d4daa2ce827fb439"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
